module.exports = __webpack_public_path__ + "img/auburn-univ.d66b3a47.jpg";